import OtherIncome from './OtherIncome';

export default OtherIncome;
